import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PoolActivity } from '../models/pool-activity';
import { environment } from '../../../environments/environment';
import { PaginationResult } from '../models/pagination-result';

@Injectable({
  providedIn: 'root'
})
export class PoolActivityService {
  private readonly API_URL = `${environment.apiUrl}/pool-activities`;

  constructor(private http: HttpClient) {}

  getAll(filter: any = {}): Observable<PaginationResult<PoolActivity[]>> {
    return this.http.get<PaginationResult<PoolActivity[]>>(this.API_URL, { params: filter });
  }

  add(poolActivity: PoolActivity): Observable<PoolActivity> {
    return this.http.post<PoolActivity>(this.API_URL, poolActivity);
  }

  update(id: number, poolActivity: PoolActivity): Observable<PoolActivity> {
    return this.http.put<PoolActivity>(`${this.API_URL}/${id}`, poolActivity);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }

  downloadTemplate(): Observable<Blob> {
    return this.http.get(`${this.API_URL}/template`, {
      responseType: 'blob'
    });
  }

  bulkImport(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.API_URL}/bulk-import`, formData);
  }
}
